// Farm topology, fixed at creation. Client mirror of the server's farmKind.ts —
// keep the two in sync.
//  - Host       — a farm agent runs on a machine with USB devices (default).
//  - Aggregator — the panel multiplexes remote-phone clients as the farm's
//                 devices; host-only actions (launch/docker, terminal, reboot,
//                 image version) don't apply and are hidden in the UI.
//  - Duo        — no agent/relay: the panel lists DuoPlus cloud phones (ADB
//                 enabled) via the DuoPlus API, using a per-farm API key. Same
//                 host-only actions are hidden as for aggregator.
export var FarmKind;
(function (FarmKind) {
    FarmKind["Host"] = "host";
    FarmKind["Aggregator"] = "aggregator";
    FarmKind["Duo"] = "duo";
    FarmKind["Geelark"] = "geelark";
    FarmKind["Adspower"] = "adspower";
    FarmKind["MercadoApi"] = "mercado_api";
})(FarmKind || (FarmKind = {}));
export const DEFAULT_FARM_KIND = FarmKind.Host;
export function normalizeFarmKind(value) {
    if (value === FarmKind.Aggregator)
        return FarmKind.Aggregator;
    if (value === FarmKind.Duo)
        return FarmKind.Duo;
    if (value === FarmKind.Geelark)
        return FarmKind.Geelark;
    if (value === FarmKind.Adspower)
        return FarmKind.Adspower;
    if (value === FarmKind.MercadoApi)
        return FarmKind.MercadoApi;
    return FarmKind.Host;
}
/** True for aggregator (remote-phone) farms — the UI gate for host-only controls. */
export function isAggregatorFarm(kind) {
    return kind === FarmKind.Aggregator;
}
/** True for DuoPlus cloud-phone farms. */
export function isDuoFarm(kind) {
    return kind === FarmKind.Duo;
}
/** True for GeeLark cloud-phone farms (synced via the GeeLark Open API). */
export function isGeelarkFarm(kind) {
    return kind === FarmKind.Geelark;
}
/** True for AdsPower web-reader farms (a dockerized agent reads deposits from a bank page
 *  open in an AdsPower profile and reports over HTTP with the farm key). */
export function isAdspowerFarm(kind) {
    return kind === FarmKind.Adspower;
}
/** True for Mercado API farms: devices are Mercado Pago accounts (API key + CVU) that the
 *  mercado-runner polls — no clicker, no phones, no agent. */
export function isMercadoApiFarm(kind) {
    return kind === FarmKind.MercadoApi;
}
/** True for any cloud-phone farm reached over a public adb endpoint (duo or geelark) —
 *  the host-runner clicker + no-agent grid path is shared by both. */
export function isCloudPhoneFarm(kind) {
    return isDuoFarm(kind) || isGeelarkFarm(kind);
}
/** True for any agent-less farm (aggregator, duo, geelark or adspower) — hides host-only
 *  UI (Health/Terminal/version/restart-with-update/ADB proxy). AdsPower has its own docker
 *  agent, but none of the host-runner relay controls apply to it. */
export function isHostlessFarm(kind) {
    return isAggregatorFarm(kind) || isDuoFarm(kind) || isGeelarkFarm(kind) || isAdspowerFarm(kind) || isMercadoApiFarm(kind);
}
